(function () {
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(navigator.language || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function findQuantityInput(container) {
    var form = container.closest('form') || document;
    return form.querySelector('input[name="quantity"]');
  }

  function updateTieredPricing(container) {
    var qtyInput = findQuantityInput(container);
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var tiers = Array.prototype.slice.call(
      container.querySelectorAll('.tiered-pricing__tier')
    );

    var activeTier = null;
    tiers.forEach(function (tierEl) {
      var tierQty = parseInt(tierEl.getAttribute('data-qty'), 10);
      if (tierQty <= qty && (!activeTier || tierQty > parseInt(activeTier.getAttribute('data-qty'), 10))) {
        activeTier = tierEl;
      }
    });

    tiers.forEach(function (tierEl) {
      tierEl.classList.toggle('is-active', tierEl === activeTier);
    });

    var savingsEl = container.querySelector('[data-tiered-pricing-savings]');
    if (!savingsEl) return;

    var discount = activeTier ? parseInt(activeTier.getAttribute('data-discount'), 10) : 0;
    var basePrice = parseInt(container.getAttribute('data-base-price'), 10) || 0;
    var currency = container.getAttribute('data-currency') || 'USD';

    if (discount > 0) {
      var lineTotal = basePrice * qty;
      var savings = Math.round(lineTotal * (discount / 100));
      savingsEl.hidden = false;
      savingsEl.textContent =
        'You save ' + formatMoney(savings, currency) + ' with this quantity';
    } else {
      savingsEl.hidden = true;
      savingsEl.textContent = '';
    }
  }

  function init() {
    var containers = document.querySelectorAll('[data-tiered-pricing]');
    containers.forEach(function (container) {
      var qtyInput = findQuantityInput(container);
      if (!qtyInput) return;

      updateTieredPricing(container);

      qtyInput.addEventListener('change', function () {
        updateTieredPricing(container);
      });
      qtyInput.addEventListener('input', function () {
        updateTieredPricing(container);
      });

      container.querySelectorAll('.tiered-pricing__tier').forEach(function (tierEl) {
        tierEl.style.cursor = 'pointer';
        tierEl.addEventListener('click', function () {
          var tierQty = tierEl.getAttribute('data-qty');
          qtyInput.value = tierQty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();